import { IPosition } from 'src/interfaces/location'

const defaultOptions: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 0,
  timeout: 5000
}

export const getBrowserPosition = (
  success: PositionCallback,
  error?: (err: GeolocationPositionError | Error) => void,
  options: PositionOptions = defaultOptions
): void => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      success,
      error as PositionErrorCallback,
      options
    )
  } else {
    if (error) {
      error(new Error('Browser dont support navigator.geolocation'))
    }
  }
}

// Calculation from leaflet.
export const distance = (position1: IPosition, position2: IPosition) => {
  const r = 6371000
  const rad = Math.PI / 180
  const lat1 = position1.latitude * rad
  const lat2 = position2.latitude * rad

  const a = Math.sin(lat1) * Math.sin(lat2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.cos((position2.longitude - position1.longitude) * rad)

  return r * Math.acos(Math.min(a, 1))
}
